import React from 'react';

import { useIntake } from '../context/IntakeContext';
import { useStepNav } from '../hooks/useStepNav';
import StepLayout from '../components/StepLayout';
import { Checkbox } from '../components/ui/checkbox';

/**
 * Step 4 — the extras, split off the damage step so neither page is a wall.
 *
 * The optional services come from the shop's own settings; every shop prices
 * this differently, so a shop that hasn't configured any is simply never asked
 * and the step shows the loan vehicle question alone.
 */
const Option = ({ checked, onChange, label, note }) => (
  <label className="flex cursor-pointer items-start gap-3 rounded-lg bg-muted/50 p-3">
    <Checkbox checked={checked} onCheckedChange={onChange} className="mt-0.5" />
    <span className="text-sm">
      {label}
      {note && <span className="block text-xs text-muted-foreground">{note}</span>}
    </span>
  </label>
);

const WorkshopStep = () => {
  const { form, update, save, organisation } = useIntake();
  const go = useStepNav();

  const services = organisation?.services || [];
  const selected = form.selectedServices || {};

  const handleNext = () => {
    save();
    go('photos');
  };

  return (
    <StepLayout
      title="While it's in the workshop"
      onBack={() => go('damage')}
      onNext={handleNext}
    >
      <Option
        checked={form.needsLoanVehicle === true}
        onChange={(checked) => update({ needsLoanVehicle: checked === true })}
        label="I need a loan vehicle"
      />

      {services.map((service) => (
        <Option
          key={service.id}
          checked={Boolean(selected[service.id])}
          onChange={() => update({
            selectedServices: { ...selected, [service.id]: !selected[service.id] }
          })}
          label={service.label}
          note={service.price}
        />
      ))}
    </StepLayout>
  );
};

export default WorkshopStep;
